import {GadgetConfigAdapter} from './GadgetConfigAdapter';
import {GadgetType} from '../models/GadgetType';
import {GadgetConfig} from '../../models/GadgetConfig';

export class ReadingGadgetConfigAdapter implements GadgetConfigAdapter<GadgetConfig> {
  getGadgetType(): string {
    return GadgetType.READING;
  }
  
  adapt(config: any): GadgetConfig {
    return {
      ...config,
      title: config.title || config.tocTitle
    };
  }
}
